export default "__VITE_ASSET__Dp_CO2EM__"